module.exports = __webpack_public_path__ + "static/media/isometric-house-new.c2bdb30e.png";